import React from "react"
import styled from "styled-components"

const MainArea = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    margin: 0;
`

export default props => <MainArea className="row g-2">{props.children}</MainArea>


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/components/FooterActionsPOS/MainSection/index.jsx